import React, { PureComponent } from "react"
import MembershipUpgradeCard from "./MembershipUpgradeCard"
import { withTranslation } from "react-i18next"
import { UBER_CANADA_PLACEHOLDER_PLAN } from "../../../v1/helpers/affiliationHelpers"

class MembershipUpgradeContent extends PureComponent {
  render = () => {
    const {
      onSelectMembership,
      selectedMembership,
      availableMembershipPlans,
      currentMembershipPlan,
      isDashboardModal,
      isAffiliation,
      isUberCanadaUser,
      user
    } = this.props
    let nextUpgrades =
      isAffiliation || isDashboardModal
        ? availableMembershipPlans || []
        : this.props.nextUpgrades || []
    if (isUberCanadaUser) {
      // Hardcoded, not API-driven: always show the one Uber Canada Premium card regardless of
      // what /api/v4/membership_plans returns for this account/environment.
      nextUpgrades = [UBER_CANADA_PLACEHOLDER_PLAN]
    }
    if (selectedMembership == {}) return null

    return (
      <div className="membership-upgrade-content">
        <div className="membership-upgrade-cards">
          {nextUpgrades.map((plan) => {
            return (
              <MembershipUpgradeCard
                style={nextUpgrades.length > 1 ? { width: "49%" } : {}}
                key={`MembershipUpgradeContent-${plan.name}`}
                plan={plan}
                onSelectMembership={onSelectMembership}
                isSelected={plan.name === selectedMembership.name}
                currentMembershipPlan={currentMembershipPlan}
                isAffiliation={isAffiliation}
                isDashboardModal={isDashboardModal}
                isUberCanadaUser={isUberCanadaUser}
                user={user}
              />
            )
          })}
        </div>
      </div>
    )
  }
}

export default withTranslation("membershipUpgradeContent")(MembershipUpgradeContent)
